import { Injectable } from '@angular/core';
import { CanActivate, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';
import { BaseCoreState, baseSharedSelectors, baseSharedActions } from '../../_store';

@Injectable({ providedIn: 'root' })
export class BaseProfileGuard implements CanActivate {
  constructor(private store: Store<BaseCoreState>) {}

  canActivate() {
    return this.check$();
  }

  private check$(): Observable<boolean | UrlTree> {
    return this.store.select(baseSharedSelectors.getProfile).pipe(
      take(1),
      tap((state) => {
        if (state.ok === undefined && !state.data) {
          this.store.dispatch(baseSharedActions.loadProfileData());
        }
      }),
      switchMap(() =>
        this.store.select(baseSharedSelectors.getProfile).pipe(
          filter((state) => state.ok !== undefined),
          take(1),
          map((state) => !!state.ok)
        )
      )
    );
  }
}
